import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { MAIN_NAV } from './navigation';

export function MobileBottomNav() {
  return (
    <Bar aria-label="모바일 메인 메뉴">
      {MAIN_NAV.map(({ to, label, Icon }) => (
        <NavItem key={to} to={to}>
          <Icon size={20} />
          <span>{label}</span>
        </NavItem>
      ))}
    </Bar>
  );
}

const Bar = styled.nav`
  display: none;

  @media (max-width: 900px) {
    display: flex;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 30;
    align-items: stretch;
    justify-content: space-around;
    gap: 2px;
    padding: 6px 8px calc(6px + env(safe-area-inset-bottom, 0px));
    border-top: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.headerBg};
    backdrop-filter: blur(16px);
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.06);
  }
`;

const NavItem = styled(NavLink)`
  flex: 1;
  min-width: 0;
  min-height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 4px;
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.textMuted};
  text-align: center;

  svg {
    flex-shrink: 0;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  &.active {
    color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.primarySoft};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;
